(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('BHTDashboardController', BHTDashboardController);

    BHTDashboardController.$inject = ['CoreService', '$state'];

    function BHTDashboardController(CoreService, $state) {
        var vm = this;

        if (CoreService.getCurrentFacility() == null) {
            $state.go('home');
        }
    }
})();
